import {EventEmitter} from '@angular/core';
import {ExgEventArgs} from './ExgEventArgs';

export class ExgApplicationEventEmitter {
  Task = {
    Workspace: {
      ViewLoaded: new EventEmitter<ExgEventArgs>()
    },
    Summary: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    },
    New: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    }
  };
  Case = {
    Workspace: {
      ViewLoaded: new EventEmitter<ExgEventArgs>()
    },
    Summary: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    },
    NewTask: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    },
    NewCase: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  Calculation = {
    Version: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  DialogueQuestion = {
    DataLoaded: new EventEmitter<ExgEventArgs>()
  };
  Schedule = {
    CreateSchedule: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    UpdateSchedule: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  Questionnaire = {
    CreateUpdateVersion: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  Message = {
    Reader: {
      Closed: new EventEmitter<ExgEventArgs>(),
      LinkChanged: new EventEmitter<ExgEventArgs>()
    },
    NewForTask: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    NewForCase: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    AnswerForward: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    Repository: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    }
  };
  NoteDialog = {
    Closed: new EventEmitter<ExgEventArgs>()
  };
  Receipt = {
    Checkview: {
      CheckDuplicates: new EventEmitter<ExgEventArgs>(),
    },
    UploadDialog: {
      Closed: new EventEmitter<ExgEventArgs>(),
      Replaced: new EventEmitter<ExgEventArgs>(),
    },
    Preview: {
      Downloaded: new EventEmitter<ExgEventArgs>()
    },
    List: {
      Reload: new EventEmitter<ExgEventArgs>(),
      Deleted: new EventEmitter<ExgEventArgs>()
    },
  };
  Document = {
    UploadDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    UpdateDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    UploadSaveAsNewDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    UploadSaveEditDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    ResetEditDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    },
    PreviewDialog: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  PhotoDocumentation = {
    Download: {
      Finished: new EventEmitter<ExgEventArgs>(),
      Canceled: new EventEmitter<ExgEventArgs>()
    },
    Closed: new EventEmitter<ExgEventArgs>(),
    PreviewModal: {
      Success: new EventEmitter<ExgEventArgs>()
    }
  };
  ImageEditor = {
    OpenModal: {
      ClosedSave: new EventEmitter<ExgEventArgs>(),
      ClosedSaveAs: new EventEmitter<ExgEventArgs>(),
      ClosedReset: new EventEmitter<ExgEventArgs>(),
      Canceled: new EventEmitter<ExgEventArgs>(),
    }
  };
  OE = {
    NewOE: {
      Save: new EventEmitter<ExgEventArgs>(),
      Canceled: new EventEmitter<ExgEventArgs>(),
    },
    Summary: {
      Reload: new EventEmitter<ExgEventArgs>()
    }
  };
  ReportBuilder = {
    Preview: {
      Create: new EventEmitter<ExgEventArgs>()
    },
    PreviewOverlay: {
      Closed: new EventEmitter<ExgEventArgs>()
    }
  };
  Formular = {
    Version: {
      Closed: new EventEmitter<ExgEventArgs>(),
    },
    Template: {
      Closed: new EventEmitter<ExgEventArgs>(),
    },
  };

  Leistungserfassung = {
    New: {
      Save: new EventEmitter<ExgEventArgs>()
    },
    Summary: {
      DataLoaded: new EventEmitter<ExgEventArgs>()
    }
  };

  [key: string]: undefined | any;
}
